<template>
  <div>
    <div class="rank-li flex align-center" style="border:none" v-if="rankWord">
      <p v-if="wordInfo.rank!=null">
        <!-- Ranking: -->
        <span v-if="!type">{{ showRankText && '' || '' }}</span>
        <span style="color: #666" :class="{'ranking-error':isWarn}">{{ formatRank }}</span>
      </p>
      <span
        v-if="showDiff && wordInfo.diff !== '-1'"
        :class="formatDiff(wordInfo.diff,1).className"
      >{{ formatDiff(wordInfo.diff).diff }}</span>
    
      <span v-if="wordInfo.rank<=0" style="white-space: nowrap;" :class="{'ranking-error':!isWarn}">{{ showRedOut }}</span>
      <!-- <i v-if="wordInfo.rank" class="iconfont icon-youxiang" @click.stop="rankDetail" /> -->
      <img v-if="wordInfo.rank" class="rank-icon" :src="rankIcon" @click.stop="rankDetail">
      <van-loading v-if="wordData.infoWord.loading" type="spinner" size="14" />
      <img v-else-if="showRefresh" :src="refreshImg" @click.stop="onWordRefresh">
    <!-- <van-icon v-else-if="showRefresh" name="replay" @click.stop="onWordRefresh" /> -->
    </div>

    <!-- score -->
    <div class="rank-li flex align-center" style="border:none" v-if="scoreWord">
      <div v-if="wordInfo.score >0">
        <span>{{ wordInfo.score }}</span>
        <!-- <img v-if="wordInfo.score" class="rank-icon" :src="rankIcon" @click.stop="wordDetail"> -->
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </div>

    <div class="rank-li flex align-center" style="border:none" v-if="hotWord">
      <div v-if="wordInfo.hot >0">
        <span>{{ wordInfo.hot }}</span>
        <img v-if="wordInfo.hot" class="rank-icon" :src="rankIcon" @click.stop="wordDetail">
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </div>
    <div class="rank-li flex align-center" style="border:none" v-if="numWord">
      <div v-if="wordInfo.num >0">
        <span>{{ wordInfo.num }}</span>
        <img v-if="wordInfo.num" class="rank-icon" :src="rankIcon" @click.stop="wordDetail">
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </div>
    <div class="rank-li flex align-center" style="border:none" v-if="popWord">
      <div v-if="wordInfo.pop >0">
        <span>{{ wordInfo.pop }}</span>
        <img v-if="wordInfo.pop" class="rank-icon" :src="rankIcon" @click.stop="wordDetail">
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </div>
  </div>
</template>
  
<script>
import { computed, reactive ,inject,ref} from 'vue';
import { getWordRankRefresh } from 'model/common'
import { getRankHistory,getKeywordHistory } from 'model/home'
import refreshImg from 'assets/images/rank-refresh.svg'
import rankIcon from 'assets/images/rank-icon.svg'
import { useStore } from 'vuex'
export default {
  name: 'WordRankCell',
  //import 引入组件
  components: {
  },
  props:{
    // 有排名是否显示报红
    isWarn: {
      type: Boolean,
      default: () => false
    },
    wordInfo:{
      type:Object,
      required: true
    },
    showDiff: { type: Boolean, default: true },
    showRank: { type: Boolean, default: true },
    showRankText: { type: Boolean, default: true },
    type:{
      type:String,
      default:''
    },
    rankWord: { type: Boolean, default: false },
    scoreWord: { type: Boolean, default: false },
    hotWord: { type: Boolean, default: false },
    numWord: { type: Boolean, default: false },
    popWord: { type: Boolean, default: false },
  },
  setup(props,crx){
    const { big_data_error_num } = inject('error')
    const isMaintain = ref(false)
    const store = useStore()
    const wordData=reactive({
      infoWord:props.wordInfo
    })
    const toolText = ref(null)
    // 接口管理
    const api = inject('$url') 
    const {formatDiff,EnFormatDate} = inject("$common");
    async function onWordRefresh(){
      wordData.infoWord.loading = true
      //props.wordInfo.loading = true
      await getWordRankRefresh(api.POST_WORD_RANK_REFRESH,{
        platform: parseInt(props.wordInfo.platform),
        appId: props.wordInfo.appId,
        region: props.wordInfo.region,
        words: [props.wordInfo.word]
      })
    }
    const showRefresh=computed(()=>{
      return new Date().getTime() - props.wordInfo.ts > 60 * 60 * 1000 * 4
      // return new Date().getTime() -props.wordInfo.ts > 2 * 60 * 1000
    })
    // rank 排名
    const formatRank=computed(()=>{
      if (props.wordInfo.rank == null) {
        return 'unknown'
      } else if (props.wordInfo.rank <= 0) {
        return ''
      } else {
        return props.wordInfo.rank
      }
    })

    const showRedOut=computed(()=>{
      if (props.wordInfo.rank != null && props.wordInfo.rank <= 0) {
        if (props.showDiff) {
          // 如果显示diff，那么diff会显示为红色的out，这里不需要显示了
          // 这里实际上应该隐藏diff中的out，但考虑兼容性，没有这么做
          return ''
        } else {
          return 'out'
        }
      }
      return ''
    })

    const rankDetail=async()=>{
      const res = await getRankHistory({
        platform: parseInt(props.wordInfo.platform),
        appId: props.wordInfo.appId,
        region: props.wordInfo.region,
        word: props.wordInfo.word
      })
      if(res.data === big_data_error_num) {
        isMaintain.value = true
        crx.emit('rank',{
          isMaintain: true
        })
        return 
      }
      if(res.code===0){
        const dateTime=[]
        const data=[]
        res.data.forEach(item => {
          dateTime.push(EnFormatDate(item.timestamp))
          data.push(item.rank)
        })
        const config = {
          xData: dateTime, // x 轴坐标
          data: data ,// 数据
          text: 'Rank',
          isRe: true
        };
        crx.emit('rank',config)
      }
    }
    const wordDetail=async()=>{
      const res = await getKeywordHistory({
        platform: parseInt(props.wordInfo.platform),
        region: props.wordInfo.region,
        keyword: props.wordInfo.keyword || props.wordInfo.word,
        hotHistory: props.hotWord,
        numHistory: props.numWord,
        popHistory: props.popWord
      })
      if(res.data === big_data_error_num) {
        isMaintain.value = true
        crx.emit('wordRank',{
          isMaintain: true
        })
        return 
      }
      if(res.code===0){
        const dateTime=[]
        const data=[]
        let isRe = true
        res.data.forEach(item => {
          dateTime.push(EnFormatDate(item.timestamp))
          if(props.hotWord){
            data.push(item.hot)
            toolText.value = 'Search Volume'
            isRe = false
          } else if(props.numWord){
            data.push(item.num)
            toolText.value = 'Search Results'
          }else if(props.popWord){
            data.push(item.pop)
            toolText.value = 'Popularity'
          }
        })
        const config = {
          xData: dateTime, // x 轴坐标
          data: data, // 数据
          text: toolText.value,
          isRe
        };
        crx.emit('wordRank',config)
      }
    }
    const dashboard=computed(()=>{
      return store.state.dashboard
    })
    
    
    return {onWordRefresh,showRefresh,formatRank,showRedOut,formatDiff,rankDetail,wordDetail,wordData,refreshImg,rankIcon,dashboard}
  }
}
</script>
  
<style scoped lang="scss">
  .rank-li {
    border-bottom: 1px solid #fff;
    justify-content: center;

    &:nth-child(1) {
      color: #262626;;
      margin-right: 5px;
    }

    .ranking-plus {
      color: #27c227;
    }

    .ranking-minus,
    .ranking-error {
      color: red;
    }

    .rank-icon {
      width: 22px;
      height: 18px;
      margin-right: 5px;
      margin-left: 5px;
      vertical-align: text-top;
    }
  }


@media screen and (max-width: 375px) {
.rank-li{
padding: 10px 5px;
// flex-wrap: wrap;
&:nth-child(1){
 margin-right: 0;
 flex-wrap: wrap;
}
}
}


.maintain-wrap {
    padding: 16px;
    text-align: center;
    border-radius: 0px 0px 0px 0px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.maintain-text {
    color: #666;
    font-size: 12px;
}
.maintain-btn {
    /deep/ .el-button {
        background: rgba(97,83,255,0.1);

        span {
            font-size: 12px;
            color: #6153ff;
        }
    }
}





  
</style>